import { allEnumValues, DiscountLevel, DiscountType } from '@biteinc/enums';
import { AbstractModelSchema } from './abstract_model_schema.js';
const couponFieldsWithoutCouponCodes = {
    name: {
        type: 'shortString',
        required: true,
    },
    posDiscountID: {
        type: 'keyString',
        displayName: 'POS Discount ID',
        required: true,
        tooltip: {
            text: 'This is the discount you want to be used on the POS for these codes. Ask your POS account manager for this string.',
        },
    },
    posIntegrationId: {
        displayName: 'POS Integration',
        type: 'mongoId',
        required: true,
        isPermanent: true,
        isHidden: true,
    },
    posDiscountIsOpen: {
        type: 'bool',
        displayName: 'POS Discount is open',
    },
    level: {
        type: 'int',
        values: allEnumValues(DiscountLevel),
        required: true,
        ui: 'dropdown',
    },
    type: {
        type: 'int',
        values: allEnumValues(DiscountType),
        required: true,
        ui: 'dropdown',
    },
    amount: {
        type: 'price',
        required: true,
    },
    itemIds: {
        type: 'array',
        elementType: 'mongoId',
        displayName: 'Items (for item-level discounts only)',
        ui: 'table',
        placeholder: 'Select Menu Item',
        conditions: [
            {
                field: 'level',
                values: [DiscountLevel.Item],
            },
        ],
    },
    modifierIds: {
        type: 'array',
        elementType: 'mongoId',
        displayName: 'Modifiers (for item-level discounts only)',
        ui: 'table',
        placeholder: 'Select Modifiers',
        conditions: [
            {
                field: 'level',
                values: [DiscountLevel.Item],
            },
        ],
    },
    itemIdsBlacklist: {
        type: 'array',
        elementType: 'mongoId',
        displayName: 'Excluded Items (for check-level discounts only)',
        tooltip: {
            text: 'These items will not be discounted when using this coupon. For example, a $5 off coupon on a $6 order with a $2 item excluded will only apply $4 off.',
        },
        ui: 'table',
        placeholder: 'Select Menu Item',
        conditions: [
            {
                field: 'level',
                values: [DiscountLevel.Check],
            },
        ],
    },
    modifierIdsBlacklist: {
        type: 'array',
        elementType: 'mongoId',
        displayName: 'Excluded Modifiers (for check-level discounts only)',
        tooltip: {
            text: 'These mods will not be discounted when using this coupon.',
        },
        ui: 'table',
        placeholder: 'Select Modifiers',
        conditions: [
            {
                field: 'level',
                values: [DiscountLevel.Check],
            },
        ],
    },
    singleUseCodes: {
        type: 'bool',
        displayName: 'Retire codes after usage (e.g. for Thanx)',
    },
    effectiveDate: {
        type: 'object',
        displayName: 'Effective during',
        subtype: 'DateRange',
    },
    retireAtOrgLevel: {
        type: 'bool',
        displayName: 'Retire coupon at org level',
    },
};
export const couponRequestSchema = {
    displayName: 'coupon',
    type: 'object',
    fields: {
        ...couponFieldsWithoutCouponCodes,
        couponCodes: {
            type: 'longString',
            required: true,
            displayName: 'Coupon Codes (comma separated)',
            // 'These are going to be stored as an array of keyStrings in the db and converted back and forth to/from CSV for presentation purposes only.'
        },
    },
};
export const couponModelSchema = {
    displayName: 'coupon',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        orgId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        locationId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        menuId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        ...couponFieldsWithoutCouponCodes,
        couponCodes: {
            type: 'array',
            elementType: 'keyString',
            required: true,
            displayName: 'Coupon Codes',
            // 'These are going to be stored as an array of keyStrings in the db and converted back and forth to/from CSV for presentation purposes only.'
        },
    },
};
//# sourceMappingURL=coupon_schema.js.map